import React from "react";
import { InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

import { MUICustomAutocompleteSelect } from "@/components/muiCustom/select/MUICustomAutocompleteSelect";

type BrandRequestTypeOption = {
  id?: string | number;
  name: string;
};

type RequestTypeSelectorProps = {
  onChange: (_value: string) => void;
  selectedRequestType: string;
  brandRequestList?:
    | BrandRequestTypeOption[]
    | Record<string, BrandRequestTypeOption>;
};

const StyledMUICustomAutocompleteSelect = styled(MUICustomAutocompleteSelect)(
  ({ theme }) => ({
    "& .MuiInputBase-input::placeholder": {
      color: theme.palette.text.placeholder,
      opacity: 1,
    },
  })
);

const RequestTypeSelector = ({
  onChange,
  selectedRequestType,
  brandRequestList,
}: RequestTypeSelectorProps) => {
  const requestTypeOptions = brandRequestList
    ? Object.values(brandRequestList).map((v) => ({
        label: v.name,
        value: v.name,
      }))
    : [];

  return (
    <>
      <InputLabel
        shrink
        margin="dense"
        disableAnimation
        style={{
          color: "var(--neutral-700)",
          fontSize: ".92rem",
          fontWeight: "700",
          padding: "0px",
        }}
        className="px-2 pb-1 m-0"
        required
      >
        What Can We Help You With?
      </InputLabel>
      <StyledMUICustomAutocompleteSelect
        options={requestTypeOptions}
        selectProps={{
          value: selectedRequestType,
          onChange: onChange,
        }}
        className="w-100 px-2 py-2 pr-0 p-0 m-0 "
        size="small"
        name="requestType"
        placeholder="Please select"
        color="contrastText"
      />
    </>
  );
};

export default RequestTypeSelector;
